import { Table as MantineTable } from '@mantine/core'

import type { TableProps } from '@/components/Table/Table.types'

import classes from './Table.module.css'

export function Table({ columns, rows }: TableProps) {
  const headColumns = columns.map(column => (
    <MantineTable.Th
      key={column.key}
      className={classes.column}
      w={column.size || 'auto'}
    >
      {column.label}
    </MantineTable.Th>
  ))

  const displayedRows = rows.map(row => (
    <MantineTable.Tr key={row[0].key}>
      {row.map(item => (
        <MantineTable.Td key={item.key} className={classes.row}>
          {item}
        </MantineTable.Td>
      ))}
    </MantineTable.Tr>
  ))

  return (
    <MantineTable className={classes.table}>
      <MantineTable.Thead>
        <MantineTable.Tr>{headColumns}</MantineTable.Tr>
      </MantineTable.Thead>

      <MantineTable.Tbody>{displayedRows}</MantineTable.Tbody>
    </MantineTable>
  )
}
